import { ENV_VARS } from 'constants/environment.constants';
import { HttpStatusCodeResponse } from 'constants/http-statuscodes';
import { kf1AuthenticatedHttpClient } from 'kfone-frontend-core';
import { IReportsListResponse } from 'model/interfaces/reports-list';
import { ReportRunHistory } from 'model/types';



export const getReportsListList = async (): Promise<IReportsListResponse> => {
  try {
    const config = {
      url: 'v3/report/getall' ,
      method: 'GET',
      baseURL: ENV_VARS.API_URL,
    };
    const res = await kf1AuthenticatedHttpClient(config);
    return res.data;
  } catch (error: any) {
    console.error('Error fetching country list:', error);
    return error?.response?.data ?? HttpStatusCodeResponse.InternalServerError;
  }
};


export const deleteReport = async (reportId:any): Promise<IReportsListResponse> => {
  try {
    const config = {
      url: 'report/delete?reportId='+reportId ,
      method: 'DELETE',
      baseURL: ENV_VARS.API_URL,
    };
    const res = await kf1AuthenticatedHttpClient(config);
    return res.data;
  } catch (error) {
    console.error('Error deleting report:', error);
    throw error;
  }
};

  export const getReport = async (reportId:any): Promise<{responseCode: number, data: IReportsListResponse, message: string}> => {
  try {
    const config = {
      url: 'report/get?reportId='+reportId ,
      method: 'GET',
      baseURL: ENV_VARS.API_URL,
    };
    const res = await kf1AuthenticatedHttpClient(config);
    return res.data;
  } catch (error) {
    console.error('Error Getting report:', error);
    throw error;
  }
};

export const getReportRunHistory = async (reportId: any): Promise<any> => {
  try {
    const config = {
      url: 'costplanning/runhistory?reportId=' + reportId,
      method: 'GET',
      baseURL: ENV_VARS.API_URL,
    };
    const res = await kf1AuthenticatedHttpClient(config);
    return res.data;
  } catch (error: any) {
    console.error('Error getting report run history:', error);
    return error?.response?.data ?? HttpStatusCodeResponse.InternalServerError;
  }
};

export const getDownloadList = async () => {
  try {
    const config = {
      url: 'pdfreport/getallpdfreports',
      method: 'GET',
      baseURL: ENV_VARS.API_URL,
    };
    const res = await kf1AuthenticatedHttpClient(config);
    return res.data;
  } catch (error) {
    console.error('Error fetching pdf report list:', error);
    throw error;
  }
};

export const deletePdfReport = async (pdfId:any,type:any): Promise<IReportsListResponse> => {
  try {
    const config = {
      url: 'pdfreport/deletepdfreport?reportId='+pdfId+'&type='+type ,
      method: 'DELETE',
      baseURL: ENV_VARS.API_URL,
    };
    const res = await kf1AuthenticatedHttpClient(config);
    return res.data;
  } catch (error) {
    console.error('Error deleting recent pdf report:', error);
    throw error;
  }
};

export type DownloadRecentReportResponse = {
  responseCode: number;
  responseMessage?: string;
  data?: {
    presignedUrl?: string;
    downloadCount?: number;
    [key: string]: unknown;
  };
};

export const downloadRecentReport = async (
  id: string | number,
  type: string
): Promise<DownloadRecentReportResponse> => {
  try {
    const config = {
      url: `download/presignedurl?id=${id}&type=${type}`,
      method: 'GET',
      baseURL: ENV_VARS.API_URL,
    };
    const res = await kf1AuthenticatedHttpClient(config);
    return res.data;
  } catch (error) {
    console.error('Error downloading recent pdf report:', error);
    throw error;
  }
};



